import './restaurantCard.scss';

export const RestaurantCardComponent = {
    bindings: {
        restaurant: '<',
        managementGroupGuid: '<?'
    },
    template: `
        <div class="restaurant-card">
            <a class="restaurant-card-link"
               href="/{{::$ctrl.restaurant.shortUrl}}?managementGroupGuid={{::$ctrl.managementGroupGuid}}"
               ng-click="$ctrl.trackLinkClickEvent()">
                <div class="restaurant-card-left">
                    <p class="restaurant-name">{{::$ctrl.restaurant.name}}</p>
                    <p class="restaurant-address-info">{{::$ctrl.restaurant.address}}</p>
                    <p class="restaurant-address-info">{{::$ctrl.restaurant.city}}, {{::$ctrl.restaurant.state}} {{::$ctrl.restaurant.zip}}</p>
                </div>
                <p class="restaurant-distance-to-consumer">{{::$ctrl.restaurant.distanceFromConsumer | floatRoundingFilter}} {{::$ctrl.restaurant.distanceUnits === 'mi' ? 'miles' : 'km'}}</p>
            </a>
        </div>
    `,
    controller: class {
        constructor(consumerService, googleAnalyticsService) {
            'ngInject';
            this.consumerService = consumerService;
            this.googleAnalyticsService = googleAnalyticsService;
        }
        trackLinkClickEvent() {

            this.googleAnalyticsService.trackLinkClickEvent(this.restaurant.shortUrl);
            this.googleAnalyticsService.trackLinkClickEvent(this.consumerService.data.diningOption);
            this.googleAnalyticsService.trackLinkClickEvent(
                'shortUrl: ' + this.restaurant.shortUrl
                    + ', diningOption: ' + this.consumerService.data.diningOption
            );
        }
    }
};
